"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { ArrowRight } from "lucide-react";
export default function OurStory() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section id="our-story" className="bg-background py-24 lg:py-32 overflow-hidden">
      <div ref={sectionRef} className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {}
          <div className={cn("relative transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10")}>
            <div className="relative rounded-sm overflow-hidden shadow-2xl bg-muted">
              <AspectRatio ratio={4 / 5}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1443870/img/esg_collaborative_session_bw.png" alt="EduStrategy Group team in a collaborative strategic session" className="object-cover w-full h-full grayscale hover:grayscale-0 transition-all duration-700 ease-in-out" />
              </AspectRatio>
              {}
              <div className="absolute inset-0 border-1 border-white/10 pointer-events-none mix-blend-overlay" />
            </div>
          </div>

          {}
          <div className={cn("flex flex-col gap-8 transition-all duration-1000 delay-300 ease-out transform", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
            <div className="space-y-6">
              <span className="text-primary font-bold tracking-widest uppercase text-xs md:text-sm border-b border-primary/20 pb-2 inline-block">
                Growth You Own
              </span>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-primary leading-[1.1]">
                We build capability with you, not dependency on us.
              </h2>
            </div>

            <div className="space-y-6 text-lg text-muted-foreground font-sans leading-relaxed max-w-xl">
              <p>
                For mission-driven education institutions and nonprofits that
                need sustainable growth without losing their soul, EduStrategy
                Group is the strategic growth partner that co-designs lifelong
                learning ecosystems.
              </p>
              <p>
                Unlike traditional consulting firms that extract expertise and
                leave, we embed capacity inside your organization — so the
                growth you achieve is growth you own.
              </p>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm px-8 py-7 text-base tracking-wide uppercase font-bold shadow-md">
                <Link to="https://edustrategygroup.com/schedule-your-strategy-session/">
                  Start a Conversation <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}